import { MenuM } from "@common/components/menu/MenuM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React from "react"
import { useController } from "react-hook-form"
import { View } from "react-native"
import { Text } from "react-native-paper"
import { renderers } from "react-native-popup-menu"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"

export const SelectInputM = ({
    style,
    onSelect,
    label,
    sliderLabel = label,
    options,
    value,
    name,
    control = null,
    noLabel = false,
    labelComponent,
    errors,
    optionHeight,
    disabled = false,
    compact = false, // compact display: no background/border, underline value
    placeholder,
}) => {
    const { field } = control
        ? useController({
              name,
              control,
          })
        : { field: null }

    const currentValue =
        value !== undefined && value !== null ? value : field?.value
    const selectedOption = options?.find((x) => x?.value === currentValue)
    const isPlaceholder = !selectedOption
    const selectedValueLabel = selectedOption?.label ?? placeholder

    const isControlAvailable = !!field

    const handleOptionSelect = (selectedOptionValue) => {
        onSelect(selectedOptionValue)
        if (isControlAvailable) {
            field?.onChange(selectedOptionValue)
        }
    }

    return (
        <MenuM
            name={name}
            disabled={disabled}
            center
            buttonComponent={
                <>
                    {!noLabel && !compact && (
                        <TextM
                            color={theme.colors.primary}
                            wrap
                            fontWeight={"Medium"}
                            fontSize={12}
                        >
                            {label}
                        </TextM>
                    )}
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: compact ? "flex-start" : "space-between",
                            borderRadius: theme.roundness,
                            paddingVertical: compact ? 0 : 10,
                            paddingHorizontal: compact ? 0 : 15,
                            marginTop: compact ? 0 : 2,
                            borderWidth: compact ? 0 : 1,
                            borderColor:
                                compact ? 'transparent' : (errors && errors[name]
                                    ? theme.colors.error
                                    : theme.colors.lightMore),
                            backgroundColor: compact ? 'transparent' : theme.colors.primaryLighter,
                            minHeight: compact ? undefined : 40,
                        }}
                    >
                        {labelComponent ? (
                            labelComponent
                        ) : (
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    flex: compact ? undefined : 1,
                                    marginRight: compact ? 6 : 10,
                                }}
                            >
                                {selectedOption?.leftComponent ?? null}
                                <TextM
                                    color={
                                        compact
                                            ? theme.colors.grey
                                            : isPlaceholder
                                            ? theme.colors.light
                                            : theme.colors.primary
                                    }
                                    fontWeight={
                                        compact || !isPlaceholder
                                            ? "Medium"
                                            : "Regular"
                                    }
                                    fontSize={14}
                                    wrap
                                    style={{
                                        flex: compact ? undefined : 1,
                                        textDecorationLine: compact ? 'underline' : 'none',
                                    }}
                                >
                                    {selectedValueLabel}
                                </TextM>
                            </View>
                        )}
                        {!compact && (
                            <FontAwesome5
                                name={"caret-down"}
                                size={18}
                                color={theme.colors.primary}
                            />
                        )}
                    </View>
                    {errors && errors[name] && (
                        <Text
                            style={{
                                color: theme.colors.error,
                                textAlign: "center",
                            }}
                        >
                            {errors[name].message}
                        </Text>
                    )}
                </>
            }
            style={{
                borderRadius: theme.roundness,
                ...style,
            }}
            items={[
                {
                    title: sliderLabel,
                    type: "title",
                },
            ].concat(
                options?.map((x) => {
                    return {
                        title: x?.label,
                        subtitle: x?.subtitle,
                        leftComponent: x?.leftComponent,
                        icon: x?.icon,
                        onPress: () => handleOptionSelect(x?.value),
                    }
                })
            )}
            optionHeight={optionHeight}
            renderer={renderers.SlideInMenu}
        />
    )
}
